<template>
  <div class="animated fadeIn">
    <global-table
      :table-data="cro_task_detail"
      :loading="loading"
      :per-page="10"
      :bordered="true"
      :table-detail="tableDetail"
      :hover="true"
      :striped="false"
      :fields="fields"
      :redirect-detail="false"
      :show-add-button="false"
      :caption="'<i class=\'fa fa-align-justify\'></i> Task detail '+employee_name"
    ></global-table>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "cro_task_detail",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cro_task_detail: [],
      loading: true,
      employee_name: "",
      fields: [
        { key: "customer_detail", label: "Nama Konsumen", sortable: true },
        { key: "owner_name", label: "Pemilik", sortable: true },
        { key: "contact_number", label: "Nomor Kontak", sortable: true },
        {
          key: "vehicle_delivery_name",
          label: "Kendaraan Yang Mengirim",
          sortable: true
        },
        { key: "order_time_routine_name", label: "Hari Order", sortable: true },
        { key: "dc_name", label: "Distribution Center", sortable: true },
        { key: "bank_account", label: "Bank Account", sortable: true }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function(task_id) {
      this.loading = true;
      this.getData(task_id);
    },
    getData: function(task_id) {
      this.axios
        .get("web/cvo/all-cvo-detail/" + task_id + "/")
        .then(response => {
          this.cro_task_detail = response.data.data;
          this.employee_name = response.data.employee_name;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>

<style>
</style>